export const EM_DASH = "—";

const USD_FORMAT = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

// Percentage stores 85 for "85%" (not 0.85); render the stored number with
// a trailing percent sign.
export function formatPercentage(value) {
  const n = Number(value);
  return Number.isFinite(n) ? `${n}%` : String(value);
}

export function formatCurrency(value) {
  const n = Number(value);
  return Number.isFinite(n) ? USD_FORMAT.format(n) : String(value);
}

// The numeric validation types accept their decorated input forms ("85%",
// "$1,234.56") in the editor; strip the decoration client-side so the value
// the API receives is the plain number it stores.
const stripNumericDecoration = value =>
  typeof value === "string" ? value.replace(/[%$,]/g, "").trim() : value;

export function serializeForApi(value, columnType) {
  switch (columnType) {
    case "short_text":
    case "text":
    case "single_select":
    case "email":
    case "url":
    case "phone": {
      if (typeof value !== "string") return value ?? null;
      const trimmed = value.trim();
      return trimmed === "" ? null : trimmed;
    }
    case "number": {
      if (value === "" || value === null || value === undefined) return null;
      const n = Number(value);
      return Number.isFinite(n) ? n : null;
    }
    case "percentage":
    case "currency": {
      if (value === "" || value === null || value === undefined) return null;
      const stripped = stripNumericDecoration(value);
      if (stripped === "") return null;
      const n = Number(stripped);
      return Number.isFinite(n) ? n : null;
    }
    case "date": {
      if (value === "" || value === null || value === undefined) return null;
      return value;
    }
    case "boolean":
      return value;
    case "multi_select":
    case "list":
      return value ?? [];
    default:
      return value;
  }
}

export function displayValue(value, columnType) {
  if (value === null || value === undefined) return EM_DASH;

  switch (columnType) {
    case "boolean":
      return value ? "Yes" : "No";
    case "number":
      return String(value);
    case "percentage":
      return formatPercentage(value);
    case "currency":
      return formatCurrency(value);
    case "multi_select":
    case "list":
      return value.length === 0 ? EM_DASH : value.join(", ");
    default:
      return String(value);
  }
}

export function parseRowError(err, fieldId) {
  const errors = err?.response?.data?.errors;
  if (!Array.isArray(errors)) return null;
  return errors.find(e => e.field === fieldId) ?? null;
}
